import axios from 'axios'
import { Notification } from 'element-ui'

const debug = process.env.NODE_ENV !== 'production'
const request = axios.create({
  baseURL: 'https://hospital.shandonglongdahongye.cn/api',
  // baseURL: 'http://youth.picp.net:30506',
  xsrfCookieName: 'steins_csrf_token',
  xsrfHeaderName: 'x-CSRFToken',
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json;charset=UTF-8',
    'Access-Control-Allow-Headers': 'access-control-allow-methods,access-control-allow-origin,authorization,content-type',
    'Access-Control-Allow-Methods': 'GET, DELETE, POST, OPTIONS, PUT'
  },
  withCredentials: true
})
if (debug) {
  request.defaults.headers.common['x-dev'] = 'on'
}
request.interceptors.response.use((res) => {
  const data = res.data
  if (data.hasOwnProperty('code') && data.code !== 0 && data.code !== 200 && data.code !== 20000 && data.code !== 10000 && data.code !== 1) {
    Notification({
      message: String(data.message || data.msg || data.data || data.code || data.detail),
      type: 'error',
      showClose: false,
      offset: 100,
      duration: 2000
    })
    return Promise.reject(data)
  }
  if (data.detail) {
    Notification({
      message: String(data.detail),
      type: 'error',
      showClose: false,
      offset: 100,
      duration: 2000
    })
    return Promise.reject(data)
  }
  return data
}, function (err) {
  const msg = (err.response && err.response.data && err.response.data.detail) || err.message
  Notification({
    message: msg,
    type: 'error',
    showClose: false,
    offset: 100,
    duration: 2000
  })
  return Promise.reject(err)
})

export default request



// WEBPACK FOOTER //
// ./src/utils/request.js